<script>
  import { protocols } from "superagent";
  import { _ } from "svelte-i18n";
  import EnduranceVisualDisplay from "./general/endurance/EnduranceVisualDisplay.svelte";
  import EnduranceDurationDisplay from "./general/endurance/EnduranceDurationDisplay.svelte";
  import { getActivityLabel } from "./general/endurance/activityTypes.js";

  export let part = {};

  const elements = [
    {
      id: "FigureSkating.TechniqueSteps",
      label: $_("sessions.form.iceTraining.techniques.other.step"),
    },
    {
      id: "jump.salchow",
      label: $_("sessions.form.iceTraining.techniques.jump.salchow"),
      type: "jump",
      name: "S",
    },
    {
      id: "jump.loop",
      label: $_("sessions.form.iceTraining.techniques.jump.loop"),
      name: "Lo",
    },
    {
      id: "jump.flip",
      label: $_("sessions.form.iceTraining.techniques.jump.flip"),
      type: "jump",
      name: "F",
    },
    {
      id: "jump.toeloop",
      label: $_("sessions.form.iceTraining.techniques.jump.toeLoop"),
      type: "jump",
      name: "T",
    },
    {
      id: "jump.lutz",
      label: $_("sessions.form.iceTraining.techniques.jump.lutz"),
      type: "jump",
      name: "Lz",
    },
    {
      id: "jump.axel",
      label: $_("sessions.form.iceTraining.techniques.jump.axel"),
      type: "jump",
      name: "A",
    },
    {
      id: "jump.combination",
      label: $_("sessions.form.iceTraining.techniques.jump.combination"),
    },
    {
      id: "spinn.upright",
      label: $_("sessions.form.iceTraining.techniques.spin.standing"),
    },
    {
      id: "spinn.sit",
      label: $_("sessions.form.iceTraining.techniques.spin.sitSpin"),
    },
    {
      id: "spinn.camel",
      label: $_("sessions.form.iceTraining.techniques.spin.parallel"),
    },
    {
      id: "spinn.jump",
      label: $_("sessions.form.iceTraining.techniques.spin.jumpParallel"),
    },
    {
      id: "spinn.layback",
      label: $_("sessions.form.iceTraining.techniques.spin.bend"),
    },
    {
      id: "spinn.combination",
      label: $_("sessions.form.iceTraining.techniques.spin.combination"),
    },
    {
      id: "competition.shortProgram",
      label: $_("sessions.form.iceTraining.techniques.competition.short"),
      name: "SP",
    },
    {
      id: "competition.freeProgram",
      label: $_("sessions.form.iceTraining.techniques.competition.free"),
      name: "FP",
    },
    {
      id: "stepSequence",
      label: $_("sessions.form.iceTraining.techniques.other.sequence"),
      name: "StSq",
    },
    {
      id: "FigureSkating.TechniqueSteps",
      label: $_("sessions.form.iceTraining.techniques.other.step"),
    },
    {
      id: "FigureSkating.flyer",
      label: $_("sessions.form.iceTraining.techniques.other.flyer"),
    },
    {
      id: "general.game1",
      label: $_("sessions.form.iceTraining.techniques.icePlay.skateGuard"),
    },
    {
      id: "general.game2",
      label: $_("sessions.form.iceTraining.techniques.icePlay.other"),
    },
  ];
</script>

<div style="grid-column:2">
  {part.type === "technique" && part.element
    ? elements.find((element) => element.id === part.element)?.label
    : ""}
  {#if part.content}
    (<span>{part.content}</span>)
  {/if}
  {#if part.level && part.type === "technique" && part.element && elements.find((element) => element.id === part.element)?.type === "jump"}
    <span>
      ({part.level}{elements.find((element) => element.id === part.element)
        .name})</span
    >
  {/if}
  {#if part.type === "mobility"}
    <span>{$_("sessions.form.mobility.title")}</span>
  {/if}
  {#if part.type === "mental"}
    <span>{$_("sessions.form.mental.title")}</span>
  {/if}
  {#if part.type === "endurance"}
    <span>{$_("sessions.form.endurance.title")}</span>
    {#if part.activity}
      - {getActivityLabel(part.activity, $_)}
    {/if}
  {/if}
  {#if part.type === "strength"}
    {#if part.focus}
      {$_("sessions.form.strength." + part.focus)} - {$_("sessions.form.strength." + part.method)}
    {:else}
      {$_("sessions.form.strength." + part.method)}
    {/if}
  {/if}
</div>
{#if part.type === "endurance" && part.metrics && (part.metrics.calm || part.metrics.moderate || part.metrics.high)}
  <EnduranceVisualDisplay {part} />
{:else if part.successful || part.repetitions}
  <div style="grid-column:3">
    {#if part.successful}
      <span>{part.successful} / </span>
    {/if}
    {part.repetitions}
  </div>
{/if}
<EnduranceDurationDisplay {part} />
